// eslint-disable-next-line no-unused-vars
import React from 'react';
import './direccion.scss';

const Direccion = () => {
    // Contenido oculto temporalmente por solicitud de rediseño
    return null;
};

export default Direccion;

/*
// ============================================================================
// CÓDIGO ORIGINAL DE LA TARJETA DE DIRECCIÓN (Guardado para reactivación futura)
// ============================================================================

import React, { useContext } from 'react';
import ReactMarkdown from 'react-markdown';
import { baseURL } from '../../../../../../../api';
import AboutusDepartmentsContext from '../../../../../../../contexts/pages/aboutus/departments/departmentsContext';
import { FaEnvelope, FaQuoteLeft, FaGraduationCap } from 'react-icons/fa';

const DireccionOriginal = () => {
    const { direction } = useContext(AboutusDepartmentsContext);

    const personal = direction?.tarjetas_personal?.[0] || null;

    const cargo = personal?.cargo || direction?.cargo || 'Directora General';
    const nombre = personal?.nombre || direction?.nombre || 'Dirección de Secundaria';
    const profesion = personal?.profesion || direction?.profesion || 'Liderazgo y Gestión Educativa';
    const frase = personal?.frase || direction?.frase || 'Guiando a nuestra comunidad con vocación, integridad y visión de futuro.';
    const correo = personal?.correo || direction?.correo || 'direccion@secundariababeque.edu.do';

    const descripcion = direction?.descripcion || personal?.descripcion || `
La Dirección General de Secundaria Babeque tiene a su cargo la conducción institucional, académica y formativa de nuestro colegio.

Nuestro propósito es garantizar un ambiente pedagógico de excelencia sustentado en el pensamiento crítico, la autonomía reflexiva y una sólida formación humana y ética. Acompañamos a cada estudiante para que descubra sus talentos, consolide competencias para la vida y desarrolle un compromiso activo con su entorno y el mundo.
    `;

    const rawFoto = personal?.foto?.[0]?.url || personal?.foto?.url || direction?.imagen?.[0]?.url || direction?.imagen?.url || null;
    const fotoUrl = rawFoto ? (rawFoto.startsWith('http') ? rawFoto : `${baseURL}${rawFoto}`) : null;

    return (
        <section className="direccion-container">
            <div className="direccion-inner">
                <article className="direccion-card">
                    <div className="direccion-media-col">
                        <div className="direccion-photo-wrapper">
                            {fotoUrl ? (
                                <img
                                    src={fotoUrl}
                                    alt={`Foto de ${nombre}`}
                                    className="direccion-photo"
                                />
                            ) : (
                                <div className="direccion-photo-placeholder">
                                    <FaGraduationCap className="placeholder-icon" />
                                    <span>Secundaria Babeque</span>
                                </div>
                            )}
                        </div>

                        <div className="direccion-identity">
                            <h3 className="identity-name">{nombre}</h3>
                            <p className="identity-cargo">{cargo}</p>
                            {profesion && <p className="identity-profesion">{profesion}</p>}

                            {correo && (
                                <a href={`mailto:${correo}`} className="identity-email">
                                    <FaEnvelope className="email-icon" />
                                    <span>{correo}</span>
                                </a>
                            )}
                        </div>
                    </div>

                    <div className="direccion-content-col">
                        {frase && (
                            <blockquote className="direccion-quote">
                                <FaQuoteLeft className="quote-icon" />
                                <p className="quote-text">{frase}</p>
                            </blockquote>
                        )}

                        <div className="direccion-text-body">
                            <h4 className="body-heading">Liderazgo y Misión Institucional</h4>
                            <div className="markdown-content">
                                <ReactMarkdown>
                                    {descripcion}
                                </ReactMarkdown>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </section>
    );
};
*/
